import { NumberOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import AuthContainer from '../containers/AuthContainer';
import { Button } from 'components/ui';
import { colors } from 'design';

type Props = {
  loading: boolean;
  displayCodeFull: boolean;
  displayCodeExpired: boolean;
  onSubmit: (licenseCode?: string) => void;
  onBack: () => void;
  initialLicenseCode?: string;
};

const useStyles = createUseStyles({
  codeError: {
    color: colors.dataViz.bad,
    marginTop: 4,
    marginBottom: 0,
  },
  textInput: {
    marginTop: 16,
    fontSize: 16,
    textTransform: 'lowercase',
  },
  skipButtonContainer: {
    textAlign: 'center' as const,
    marginTop: 8,
    marginBottom: 48,
  },
});

export default function RegisterLicenseCodeStep({
  loading,
  displayCodeFull,
  displayCodeExpired,
  onSubmit,
  onBack,
  initialLicenseCode,
}: Props) {
  const { t } = useTranslation();
  const styles = useStyles();
  const [form] = Form.useForm();

  const onFinish = (values: { license_code?: string }) => {
    onSubmit(values.license_code || undefined);
  };

  return (
    <AuthContainer
      title={t('loginRegister.licenseCodeStep.title')}
      description=""
      mode="register"
      bottomLinkTo="login"
      displayBackButton
      onBackButtonClick={onBack}
    >
      <Form
        form={form}
        name="license_code_step"
        onFinish={onFinish}
        layout="vertical"
        initialValues={{ license_code: initialLicenseCode }}
      >
        <p>
          <Trans i18nKey="loginRegister.licenseCodeStep.description" components={{ b: <b /> }} />
        </p>
        <Form.Item name="license_code" style={{ marginBottom: 4 }}>
          <Input
            prefix={<NumberOutlined />}
            placeholder={t('loginRegister.fields.licenseCode.placeholder')}
            allowClear
            className={styles.textInput}
          />
        </Form.Item>
        {displayCodeFull && <p className={styles.codeError}>{t('loginRegister.fields.licenseCode.full')}</p>}
        {displayCodeExpired && <p className={styles.codeError}>{t('loginRegister.fields.licenseCode.expired')}</p>}

        <Form.Item style={{ marginBottom: 0, marginTop: 16 }}>
          <Button variant="primary" block size="lg" htmlType="submit" disabled={loading} loading={loading}>
            {t('loginRegister.licenseCodeStep.submitButton')}
          </Button>
        </Form.Item>
        <div className={styles.skipButtonContainer}>
          <Button block size="lg" onClick={() => onSubmit(undefined)} disabled={loading}>
            {t('loginRegister.licenseCodeStep.skipButton')}
          </Button>
        </div>
      </Form>
    </AuthContainer>
  );
}
